module.exports = __webpack_public_path__ + "img/file-arrow-down.a86f3e73.svg";